import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import connect from 'react-redux/es/connect/connect';
import { Helmet } from 'react-helmet';
import { APPID_FACEBOOK } from 'config/constants';

class Head extends PureComponent {
    static propTypes = {
        pathname: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        description: PropTypes.string,
        image: PropTypes.string.isRequired,
        imageWidth: PropTypes.number.isRequired,
        imageHeight: PropTypes.number.isRequired
    }

    render() {
        const { name, description, image, imageWidth, imageHeight } = this.props;
        const href = window.location.href;

        return (
            <Helmet>
                <title>{name}</title>
                <link rel='canonical' href={href} />
                <meta name='description' content={description || ''} />

                <meta itemprop='name' content={name} />
                <meta itemprop='description' content={description} />
                <meta itemprop='image' content={image} />

                <meta name='twitter:card' content='summary' />
                <meta name='twitter:site' content='@Factio_org' />
                <meta name='twitter:title' content={name} />
                <meta name='twitter:description' content={description} />
                <meta name='twitter:image' content={image} />

                <meta property='og:description' content={description} />
                <meta property='og:title' content={name} />
                <meta property='og:url' content={href} />
                <meta property='og:image' content={image} />
                <meta property='og:image:width' content={imageWidth} />
                <meta property='og:image:height' content={imageHeight} />
                <meta property='og:site_name' content='Factio' />
                <meta property='og:type' content='website' />

                <meta property='fb:app_id' content={APPID_FACEBOOK} />
            </Helmet>
        );
    }
}


function mapStateToProps({ helmet }) {
    return {
        title: helmet.title,
        description: helmet.description,
        name: helmet.name,
        image: helmet.image,
        imageWidth: helmet.imageWidth,
        imageHeight: helmet.imageHeight
    };
}

function mapDispatchToProps(dispatch) {
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Head);
